export const purchaseUrl = 'https://combo-completo-running-2026.impultienda.ar/checkout'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/nEWxqDJM9sTk1aQBSFgUAK/ChatGPT_Image_14_sept_2026,_12_03_27_a.m..png'

export const heroStats = [
  ['6', 'Tomos completos'],
  ['5', 'Bonos incluidos'],
  ['5K → 21K', 'Objetivos organizados'],
  ['PDF', 'Acceso digital inmediato'],
] as const

export const pains = [
  'No sabés desde qué distancia empezar.',
  'No sabés cuántos días correr por semana.',
  'No sabés cuánto correr y cuánto caminar.',
  'No sabés cuándo aumentar kilómetros.',
  'No sabés cuándo descansar.',
  'Llegás cansado y no sabés si avanzar o repetir.',
  'Querés llegar a 5K, 10K o 21K pero no tenés un camino organizado.',
  'Hacés entrenamientos diferentes pero no sabés si están conectados entre sí.',
]

export const usageSteps = [
  ['01', 'Identificá tu nivel', 'Un test inicial te indica desde dónde empezar.'],
  ['02', 'Elegí tu objetivo', '5K · 8K · 10K · 15K · 21K'],
  ['03', 'Abrí tu semana', 'La planificación ya está armada día por día.'],
  ['04', 'Seguí el entrenamiento', 'Distancias, tiempos, ritmos y descansos definidos.'],
] as const

export const teacherSteps = [
  ['1', 'Evaluá', 'Conocé el nivel actual del alumno.'],
  ['2', 'Clasificá', 'Ubicalo según su capacidad y objetivo.'],
  ['3', 'Asigná', 'Elegí la planificación correspondiente.'],
  ['4', 'Entrená', 'Aplicá la sesión y seguí su progresión.'],
] as const

export const modules = [
  {
    icon: '📋',
    name: 'Tomo 1 — De Cero a 5K',
    period: 'Empezá desde tu nivel actual y progresá paso a paso hasta tus primeros 5K.',
    content: [
      'Test inicial: descubrí desde dónde empezar',
      'Plan de inicio → 1K',
      'Plan 1K → 3K',
      'Plan 3K → 4K',
      'Plan 4K → 5K',
      'Alternativas según disponibilidad semanal',
      'Qué hacer si no completás una sesión',
      'Cuándo repetir y cuándo avanzar',
    ],
  },
  {
    icon: '🏃',
    name: 'Tomo 2 — De 5K a 10K',
    period: 'Planes completos para seguir aumentando distancia y mejorar tu capacidad.',
    content: [
      'Plan 5K → 8K',
      'Plan 5K → 10K',
      'Plan 8K → 10K',
      'Rodajes suaves',
      'Intervalos',
      'Cambios de ritmo',
      'Cuestas',
      'Tiradas largas',
      'Plan para mejorar el rendimiento en 5K',
    ],
  },
  {
    icon: '🎯',
    name: 'Tomo 3 — De 10K a 21K',
    period: 'Planificaciones progresivas para avanzar hacia 15K o completar tus primeros 21K.',
    content: [
      'Plan 10K → 15K',
      'Plan 10K → 21K',
      'Plan 15K → 21K',
      'Tiradas largas',
      'Sesiones de calidad',
      'Semanas de menor carga',
      'Preparación para competencia',
      'Plan para mejorar 10K',
    ],
  },
  {
    icon: '💪',
    name: 'Tomo 4 — Fuerza para Runners',
    period: 'Rutinas de fuerza complementarias, listas para combinar con los días de running.',
    content: [
      'Rutinas para gimnasio',
      'Rutinas para casa',
      'Series y repeticiones',
      'Descansos',
      'Progresiones',
      'Rutinas de 15, 30 y 45 minutos',
      'Cómo combinar fuerza + running durante la semana',
    ],
  },
  {
    icon: '⚡',
    name: 'Tomo 5 — Técnica de Carrera + Preparación',
    period: 'Ejercicios y sesiones prácticas para trabajar técnica, coordinación y eficiencia.',
    content: [
      'Postura',
      'Braceo',
      'Apoyo',
      'Coordinación',
      'Skipping',
      'Aceleraciones',
      'Cuestas',
      'Series, repeticiones, metros y descansos',
      'Rutinas técnicas completas',
    ],
  },
  {
    icon: '👥',
    name: 'Tomo 6 — Sistema para Profesores de Running',
    period: 'Evaluá, clasificá y organizá corredores según su nivel, individual o en grupo.',
    featured: true,
    content: [
      'Evaluación inicial',
      'Clasificación por nivel: principiantes, 5K, 8K/10K, 15K y 21K',
      'Clases grupales listas',
      'Cómo incorporar alumnos nuevos',
      'Cómo manejar distintos niveles dentro de una misma clase',
      'Qué hacer cuando un alumno falta o no progresa como estaba previsto',
    ],
  },
]

export const bonuses = [
  {
    number: '01',
    icon: '🌡️',
    name: '50 Calentamientos + Vueltas a la Calma',
    value: '$11.990',
    description: '50 propuestas listas para usar antes y después de diferentes entrenamientos.',
    items: [
      'Opciones para principiantes, 5K, 10K y 21K',
      'Carrera suave',
      'Intervalos',
      'Cuestas',
      'Tirada larga',
      'Opciones de 5, 10 y 15 minutos',
    ],
  },
  {
    number: '02',
    icon: '🍽️',
    name: 'Nutrición e Hidratación Práctica',
    value: '$12.990',
    description: 'Orientación general y práctica alrededor de tus entrenamientos.',
    items: [
      'Antes de correr',
      'Después de correr',
      'Tiradas largas',
      'Hidratación',
      'Entrenamiento temprano',
      'Entrenamiento tarde o noche',
      'Ejemplos prácticos',
    ],
  },
  {
    number: '03',
    icon: '🛟',
    name: 'Plan B — Cuando el entrenamiento no sale',
    value: '$9.990',
    description: 'Si pasa X → sabés qué hacer. Sin perder la continuidad del plan.',
    featured: true,
    items: [
      'Perdí 1 entrenamiento',
      'Perdí varios días',
      'Perdí 1 semana',
      'Perdí 2 semanas',
      'No completé la sesión',
      'Estoy demasiado fatigado',
      'Tengo poco tiempo',
      'Llueve y no puedo salir',
      'Necesito reorganizar mi semana',
    ],
  },
  {
    number: '04',
    icon: '🏁',
    name: 'Día de Carrera — Protocolo Completo',
    value: '$12.990',
    description: 'Qué hacer paso a paso en tu 5K, 10K o 21K.',
    items: [
      'Protocolos para 5K, 10K y 21K',
      'Días previos',
      'Noche anterior',
      'Mañana de carrera',
      'Calentamiento',
      'Organización del esfuerzo',
      'Hidratación',
      'Recuperación posterior',
    ],
  },
  {
    number: '05',
    icon: '📊',
    name: 'Fichas y Planillas Profesionales',
    value: '$10.990',
    description: 'Para registrar y seguir tu progreso o el de tus alumnos.',
    items: [
      'Ficha inicial',
      'Objetivo y nivel',
      'Registro de sesiones',
      'Kilómetros y minutos',
      'RPE y fatiga',
      'Evolución',
      'Test y retest',
      'Seguimiento de alumnos',
    ],
  },
] as const

export const included = [
  '6 Tomos completos: de cero a 5K, 5K a 10K, 10K a 21K, fuerza, técnica y sistema para profesores',
  'Planificaciones por objetivo: 5K · 8K · 10K · 15K · 21K',
  'BONO 1 — 50 Calentamientos + Vueltas a la Calma (gratis)',
  'BONO 2 — Nutrición e Hidratación Práctica (gratis)',
  'BONO 3 — Plan B: cuando el entrenamiento no sale (gratis)',
  'BONO 4 — Día de Carrera: protocolo completo para 5K, 10K y 21K (gratis)',
  'BONO 5 — Fichas y Planillas Profesionales (gratis)',
  'Acceso digital en PDF + garantía de 7 días',
]

export const faqs = [
  [
    '¿Sirve si nunca corrí?',
    'Sí. El Tomo 1 arranca con un test inicial y un plan de inicio → 1K, con trote y caminata alternados, y sigue con 1K → 3K, 3K → 4K y 4K → 5K.',
  ],
  [
    '¿Sirve si ya corro 5K o 10K?',
    'Sí. El Tomo 2 tiene planes 5K → 8K, 5K → 10K y 8K → 10K, además de un plan para mejorar tu rendimiento en 5K. Si ya corrés 10K, el Tomo 3 continúa el camino.',
  ],
  [
    '¿Puedo prepararme para 21K?',
    'Sí. El Tomo 3 incluye planes 10K → 15K, 10K → 21K y 15K → 21K, con tiradas largas, sesiones de calidad, semanas de menor carga y preparación para competencia.',
  ],
  [
    '¿Me dice exactamente qué hacer cada día?',
    'Sí. Cada semana indica los días de entrenamiento con distancias o minutos, tipo de sesión, ritmo, descansos y la progresión de la semana siguiente.',
  ],
  [
    '¿Incluye días de descanso?',
    'Sí. Los descansos están dentro de la planificación semanal, y se indica cuándo repetir una semana y cuándo avanzar a la siguiente.',
  ],
  [
    '¿Incluye entrenamiento de fuerza?',
    'Sí. El Tomo 4 tiene rutinas de fuerza para corredores con series, repeticiones, descansos y progresiones, más cómo combinarlas con los días de running.',
  ],
  [
    '¿Puedo hacer la fuerza en casa?',
    'Sí. Hay rutinas para gimnasio y rutinas para casa, en versiones de 15, 30 y 45 minutos.',
  ],
  [
    '¿Sirve para profesores?',
    'Sí. El Tomo 6 es un sistema para evaluar, clasificar y organizar corredores por nivel, con clases grupales listas y fichas de seguimiento.',
  ],
  [
    '¿Puedo utilizarlo con grupos de diferentes niveles?',
    'Sí. El Tomo 6 explica cómo manejar principiantes, 5K, 8K/10K, 15K y 21K dentro de una misma clase, y cómo incorporar alumnos nuevos.',
  ],
  [
    '¿Qué pasa si pierdo entrenamientos?',
    'El Bono 3 (Plan B) resuelve esos escenarios: perdiste 1 entrenamiento, varios días, 1 o 2 semanas, no completaste la sesión, estás fatigado, tenés poco tiempo o no podés salir.',
  ],
  [
    '¿Cómo recibo los PDFs?',
    'Por email, después del pago: recibís el link de descarga en minutos. Los PDF se leen, imprimen o usan desde el celular.',
  ],
  [
    '¿Tengo acceso de por vida?',
    'Sí. Una sola compra, acceso de por vida, y las actualizaciones futuras del material quedan incluidas.',
  ],
  [
    '¿Cómo funciona la garantía?',
    'Tenés 7 días. Si no es lo que esperabas, escribís a compradigitalyaa@gmail.com y te devolvemos el 100% del pago. Sin formularios.',
  ],
] as const
